import { API, AnyObject } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";

type Args = {
  itemId: string;
  updates: AnyObject;
};

const [useUpdateItem, updateItem] = createAsyncAction(
  "items/update",
  async ({ itemId, updates }: Args) => {
    const res = await API.call<{ item: string }>({
      endpoint: `items/${itemId}`,
      method: "PUT",
      data: updates,
    });
    return { ...res, result: res.result.item };
  }
);

export default useUpdateItem;
export { updateItem };
